import { FC, ReactNode } from 'react';

import { SummaryItem } from './item';

export type SummaryListProps = {
  content: { title: ReactNode | string; value: number | ReactNode | string }[];
  icon?: ReactNode;
  name: ReactNode | string;
};

export const SummaryList: FC<SummaryListProps> = ({ name, content, icon }) => (
  <div className="flex h-fit flex-col gap-2 rounded-lg bg-gray-50 pt-2">
    <div className="flex w-full items-center justify-between px-4">
      <span className="truncate text-sm font-[550] text-gray-700">{name}</span>
      {icon}
    </div>
    <div className="divide-y-[1px] divide-gray-100 rounded-b-lg border-[1px] border-gray-100 bg-white px-4">
      {content.map((data) => (
        <SummaryItem
          key={data.title?.toString()}
          titleClassName="w-fit"
          titleWrapperClassName="w-[120px]"
          {...data}
        />
      ))}
    </div>
  </div>
);
